import { css, cx } from "@emotion/css";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { Theme } from "@/modules/theme/utils/createTheme";

import { Button, ButtonProps } from "../Button/Button";

import { ReactComponent as Arrow } from "./arrow.svg";

type ButtonWithArrowProps = ButtonProps & {
  arrowClassName?: string;
};

export const ButtonWithArrow: React.FC<ButtonWithArrowProps> = (props) => {
  const classes = createButtonWithArrowStyles(useTheme());
  const { className, arrowClassName, isLoading, children, ...rest } = props;

  return (
    <Button
      {...rest}
      isLoading={isLoading}
      className={cx(classes.root, className)}
    >
      {children}
      {!isLoading && <Arrow className={arrowClassName} />}
    </Button>
  );
};

function createButtonWithArrowStyles({ spacing }: Theme) {
  return {
    root: css({
      display: "inline-flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: spacing(2),
      "&:disabled": css({
        boxShadow: "none",
      }),
    }),
  };
}
